<template>
  <v-autocomplete
          v-model="value"
          :label="'app.search.search' | trans"
          item-text="name"
          :items="calendarEventAlphabetically"
          :return-object="true"
          :search-input.sync="searchInput"
          :hide-no-data="true"
          :disabled="!hasPermission('calendar')"
          @change="handleChangeEvent"
          dense
          browser-autocomplete="off"
  />
</template>

<script>

import {mapGetters} from "vuex";

export default {
    data: function () {
        return {
            value: {
                name: '',
            },
            searchInput: null,
        };
    },
    methods: {
        handleChangeEvent() {
            this.$emit('changeDate', {date: this.value.start_date.split(' ')[0]});
            this.value = {name: ''};
        },
    },
    computed: {
        ...mapGetters(['calendarEvents', 'hasPermission']),
      calendarEventAlphabetically() {
          if (!this.searchInput) {
            return [];
          }

          const calendarEvents = [...this.calendarEvents];
          calendarEvents.sort((ce1, ce2) => ce1.name.localeCompare(ce2.name));

          return calendarEvents;
      },
    },
}
</script>

<style scoped>

</style>
